import { render, staticRenderFns } from "./ProductFormWarningCmp.vue?vue&type=template&id=0f5016f6&"
import script from "./ProductFormWarningCmp.vue?vue&type=script&lang=js&"
export * from "./ProductFormWarningCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports